export { default } from './carousel-pagination.component'
export type { PaginationProps } from './carousel-pagination.component'
